import React, { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Table, TableSkeleton, TopProgress } from '../../../../../../components'
import {
  Container,
  TopInfoWrapper
} from './style'
import {timeConverterMMDDYYHHMM} from '../../../../../../utils/dates'
import { utilsService } from '../../../../../../api'
import { useQueryParam, NumberParam, StringParam } from 'use-query-params'
import { StateWrapper, GreenDot, Greentext } from '../../../../../cloud/Instances/styles'

type AuditLogRecord = {
  id:number
  created_at:string
  action?:string | null
  target?:string | null
  details?:string | null
}

const AuditLog:FC<any> = ({user}) => {
  const [t] = useTranslation()
  const [page] = useQueryParam('page', NumberParam)
  const [pageSize] = useQueryParam('page_size', NumberParam)
  const [ordering] = useQueryParam('ordering', StringParam)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [logs, setLogs] = useState<AuditLogRecord[]>([])
  const [paginationData, setPaginationData] = useState<any>()

  useEffect(() => {
    const currentPage = page || 1
    const currentPageSize = pageSize || 10
    const currentOrdering = ordering || '-created_at'
    const userId = user?.id || user?.user?.id

    if(!userId) return

    setPageLoading(true)
    utilsService.getActivityLog({
      page: currentPage,
      page_size: currentPageSize,
      ordering: currentOrdering,
      filtering: `user:${userId}`,
      type: 'audit'
    })
    .then((res) => {
      setLogs(res.data?.objects || [])
      setPaginationData(res.data)
    })
    .catch(() => {
      setLogs([])
      setPaginationData(undefined)
    })
    .finally(() => setPageLoading(false))
  },[page, pageSize, ordering, user])

  const columns = useMemo(() => ([
    {title:t('DATE'), key:'created_at'},
    {title:t('ACTION'), key:'action'},
    {title:t('TARGET'), key:'target'},
    {title:t('DETAILS'), key:'details'},
  ]),[t])

  const rows = useMemo(() => logs.map((item) => {
    const action = item.action || item.target || ''
    const actionStatus = action ? 'success' : 'unknown'
    return {
      ...item,
      action: (
        <StateWrapper>
          <GreenDot active={actionStatus}/>
          <Greentext active={actionStatus} style={{textTransform:'capitalize'}}>
            {action || t('NOT_AVAILABLE')}
          </Greentext>
        </StateWrapper>
      ),
      target: item.target || t('NOT_AVAILABLE'),
      details: item.details || t('NOT_AVAILABLE'),
      created_at: item.created_at ? timeConverterMMDDYYHHMM(item.created_at) : t('NOT_AVAILABLE'),
    }
  }),[logs, t])

  return(
    <Container>
      <TopProgress loading={pageLoading}/>
      <TopInfoWrapper>
        {pageLoading ? (
          <TableSkeleton rows={5} columns={columns.length} columnsData={columns}/>
        ) : (
          <Table
            columns={columns}
            rows={rows}
            hideCheckbox
            paginationData={paginationData}
            data-test-id="user-audit-log-table"
          />
        )}
      </TopInfoWrapper>
    </Container>
  )
}
export default AuditLog
